/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Container, TextField } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTable from "../../../components/Table/ThemeTable";
import { getClientsListbasedonIds } from "../../../services/apiservices/client";
import { getEmployeesListBasedOnId } from "../../../services/apiservices/employee";
import {
  getSupplyOrderList,
  updateArchive,
  updateSuppliesStatus,
  updateSupplyItemsStatus,
} from "../../../services/apiservices/supplies";
import { FormatedDates } from "../../../services/helpers";
import { Eye, Search } from "lucide-react";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
  SuppplyDataDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import AuthContext from "../../../hooks/authContext";
import { getSettings } from "../../../services/apiservices/settings";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import ArchivedDetailsDialog from "./SuppliesArchivesDetails";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../../../components/ui/card";
import { useToast } from "../../../hooks/useToast";
import { Input } from "../../../components/ui/input";

const ArchiveSupplies = (props) => {
  const auth = useContext(AuthContext);
  const [allSupplies, setAllSupplies] = React.useState([]);
  const [filteredList, setFilteredList] = React.useState([]);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [dialogConfirmOpen, setDialogConfirmOpen] = useState(false);
  const [rejectReasonDialogOpen, setRejectReasonDialogOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const [searchTerm, setsearchTerm] = React.useState("");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [expanded, setExpanded] = useState(null);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const history = useNavigate();
  const [openSupplyDialog, setOpenSupplyDialog] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [openData, setOpenData] = useState(null);
  const [settingsData, setSettingsData] = useState();
  const { toast } = useToast();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const getColumns = [
    {
      id: "orderId",
      numeric: false,
      disablePadding: true,
      label: "Order Id",
      isSortable: true,
      gray: true,
    },
    {
      id: "dateOfRequest",
      numeric: false,
      disablePadding: false,
      label: "Order Date",
      isSortable: true,
      gray: true,
    },
    {
      id: "employeeName",
      numeric: false,
      disablePadding: true,
      label: "Employee",
      isSortable: true,
      gray: true,
    },
    {
      id: "clientName",
      numeric: false,
      disablePadding: false,
      label: "Client",
      isSortable: true,
      gray: true,
    },
    {
      id: "priority",
      numeric: false,
      disablePadding: false,
      label: "Priority",
      isSortable: true,
      gray: true,
    },
    {
      id: "supplies",
      numeric: false,
      disablePadding: true,
      label: "Items",
      isSortable: true,
      gray: true,
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      isSortable: true,
      gray: true,
    },
  ];

  const ColumnsRes = [
    {
      id: "clientName",
      numeric: false,
      disablePadding: false,
      label: "Client",
      isSortable: true,
    },
    {
      id: "priority",
      numeric: false,
      disablePadding: false,
      label: "Priority",
      isSortable: true,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Order Status",
      isSortable: true,
    },
    {
      id: "dateOfRequest",
      numeric: false,
      disablePadding: false,
      label: "Order Date",
      isSortable: true,
      isCollapsible: true,
    },
    {
      id: "employeeName",
      numeric: false,
      disablePadding: true,
      label: "Employee Name",
      isSortable: true,
      isCollapsible: true,
    },
    {
      id: "supplies",
      numeric: false,
      disablePadding: true,
      label: "Supplies",
      isSortable: true,
      isCollapsible: true,
    },
    {
      id: "deliverStatus",
      numeric: false,
      disablePadding: false,
      label: "Deliver Status",
      isSortable: true,
      isCollapsible: true,
    },
    {
      id: "unArchive",
      numeric: false,
      disablePadding: false,
      label: "UnArchive",
      isSortable: true,
      isCollapsible: true,
    },
  ];

  const checkRowSearch = (searchTerm, row) => {
    const term = searchTerm.toLowerCase();
    return (
      row.status?.toLowerCase().includes(term) ||
      row.clientName?.toLowerCase().includes(term) ||
      row.employeeName?.toLowerCase().includes(term)
    );
  };

  const checkFilteredList = () => {
    if (allSupplies && Array.isArray(allSupplies)) {
      const filteredSuppliesList = allSupplies?.filter((row) => {
        return searchTerm ? checkRowSearch(searchTerm, row) : true;
      });
      setFilteredList(filteredSuppliesList);
    }
  };

  useEffect(() => {
    checkFilteredList();
  }, [allSupplies, searchTerm]);

  const fetchSuppliesList = async () => {
    try {
      setIsLoading(true);

      const [orders] = await Promise.all([
        new Promise((resolve, reject) =>
          getSupplyOrderList(
            { companyId, statusNotIn: ["Pending"] },
            resolve,
            reject
          )
        ),
      ]);

      let filterOrders = orders?.filter((item) => item?.archive === true);

      let clientIds = [
        ...new Set(filterOrders?.map((ordItem) => ordItem?.clientId)),
      ];
      let empIds = [
        ...new Set(filterOrders?.map((orderItem) => orderItem?.createdBy)),
      ];

      const [clientsResult, employeesResult] = await Promise.all([
        new Promise((resolve) => getClientsListbasedonIds(clientIds, resolve)),
        new Promise((resolve) => getEmployeesListBasedOnId(empIds, resolve)),
      ]);

      const clientsMap = new Map(
        clientsResult?.map((client) => [
          client.id,
          { value: client.id, label: client.clientName },
        ])
      );
      const employeesMap = new Map(
        employeesResult?.map((emp) => [
          emp.userId,
          {
            value: emp.userId,
            label: `${emp.firstName} ${emp.lastName}`,
            status: emp.status,
          },
        ])
      );

      const newRows = filterOrders?.map((ritem) => {
        let totalQuantity = 0;

        const client = clientsMap?.get(ritem.clientId) || {
          label: "Unknown Client",
        };
        const employee = employeesMap?.get(ritem.createdBy) || {
          label: "Unknown employee",
        };

        if (ritem.supplyItems) {
          ritem.supplyItems.forEach((item) => {
            totalQuantity += item.qty || 0;
          });
        }

        return {
          ...ritem,
          orderId: String(ritem.orderNumber).padStart(6, "0"),
          supplies: `${totalQuantity}`,
          employeeName: employee.label,
          clientName: client.label,
          employeeData: employeesResult,
        };
      });

      const sortedData = sortingFunction(newRows);
      await Promise.all([setAllSupplies(sortedData)]);

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching supplies:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliesList();
    getSettings("supplie_settings", companyId, (res) => {
      if (res?.data.length > 0) {
        const filteredData = res?.data?.filter(
          (item) => !item.deleted
        );
        const data = filteredData?.[0];
        setSettingsData(data);
      } else {
        setSettingsData();
      }
    });
  }, []);

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.orderId > b.orderId) return -1;
      if (a.orderId < b.orderId) return 1;

      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      return 0;
    });

    return result;
  };

  const redirectToDetails = (id) => {
    if (typeof id !== "undefined" && id !== "")
      history("/supplies/cleaning/archives/" + id);
  };
  const handleProceed = async (rcellItem) => {
    const formData = {
      archive: false,
    };
    const data = {
      status: "Approved",
    };
    const id = rcellItem?.id;
    const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
    try {
      if (rcellItem?.status === "Approved") {
        await updateArchive(id, formData);
      } else {
        const promises = [
          updateSuppliesStatus(id, data, name),
          updateArchive(id, formData),
        ];
        await Promise.all(promises);
        await updateSupplyItemsStatus(id, "Ordered", null);
      }
      setDialogConfirmOpen(false);
      setDetailsDialogOpen(false);
      setSelectedItem(null);
      await fetchSuppliesList();
      toast?.({
        title: "Success",
        description: "Order UnArchive Successfully",
      });
    } catch (error) {
      console.error("Error during updates:", error);
    }
  };

  const handelUnArchive = async (rcellItem) => {
    if (rcellItem?.status === "Rejected") {
      setRejectReasonDialogOpen(true);
      setSelectedItem(rcellItem);
    } else {
      setDialogConfirmOpen(true);
      setSelectedItem(rcellItem);
    }
  };

  const handleDialogConfirmClose = () => {
    setDialogConfirmOpen(false);
    setSelectedItem(null);
    setDetailsDialogOpen(false);
  };

  const getDeliveryStatus = (supplyItems) => {
    if (!supplyItems || !Array.isArray(supplyItems)) {
      return "Invalid Supplies";
    }

    const statuses = supplyItems.map((item) => item.status);

    const hasDelivered = statuses.includes("Delivered");
    const hasShipped = statuses.includes("Shipped");
    const hasOrdered = statuses.includes("Ordered");
    const hasBackOrdered = statuses.includes("Back Ordered");
    const hasCancelItem = statuses.includes("Cancel Item");

    if (
      statuses.every((status) => status === "Delivered") ||
      (hasDelivered &&
        hasCancelItem &&
        !hasOrdered &&
        !hasBackOrdered &&
        !hasShipped)
    ) {
      return "Full Delivery";
    }
    if (statuses.every((status) => status === "Cancel Item")) {
      return "cancelled";
    }
    if (
      hasDelivered &&
      (hasShipped || hasOrdered || hasBackOrdered || hasCancelItem)
    ) {
      return "Partial Delivery";
    }
    if (
      statuses.every((status) => status === "Shipped") ||
      (hasShipped &&
        hasCancelItem &&
        !hasDelivered &&
        !hasOrdered &&
        !hasBackOrdered)
    ) {
      return "Full Shipment";
    }
    if (hasShipped && (hasOrdered || hasBackOrdered) && !hasDelivered) {
      return "Partial Shipment";
    }
    if (hasOrdered && hasCancelItem) {
      return "In Process";
    }
    if (statuses.every((status) => status === "Ordered")) {
      return "In Process";
    }
    if (statuses.every((status) => status === "Back Ordered")) {
      return "Back Ordered";
    }
    if (hasOrdered && hasBackOrdered) {
      return "In Process";
    }
    return "In Process";
  };

  const handleViewDetails = (request) => {
    setCurrentRequest(request);
    setDetailsDialogOpen(true);
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };

  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "1":
        return "danger";
      case "2":
        return "warning";
      case "3":
        return "info";
      default:
        return "secondary";
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "orderId":
        return (
          <span
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            {rcellItem?.orderId}
          </span>
        );
      case "supplies":
        return <Badge variant="outline">{rcellItem?.supplies} items</Badge>;
      case "dateOfRequest":
        return FormatedDates(rcellItem?.dateOfRequest);
      case "deliverStatus":
        return <>{getDeliveryStatus(rcellItem?.supplyItems)}</>;
      case "priority":
        return (
          <Badge variant={getPriorityBadgeVariant(rcellItem?.priority)}>
            {getPriorityLabel(rcellItem.priority)}
          </Badge>
        );
      case "employeeName":
        const data = rcellItem?.employeeData?.find(
          (item) => item?.value === rcellItem?.createdBy
        );
        return (
          <p style={{ color: data?.status === false ? "#9fa6b3" : "" }}>
            {rcellItem?.employeeName}
          </p>
        );
      case "action":
        return (
          <Button
            size="sm"
            variant="outline"
            className="ml-2"
            onClick={() => handleViewDetails(rcellItem)}
          >
            <Eye className="h-4 w-4 mr-2" /> View Details
          </Button>
        );
      default:
        return rcellItem[hcellItem?.id];
    }
  };

  const handleExpandClick = (id) => {
    setExpanded((prevExpanded) => (prevExpanded === id ? null : id));
  };

  const handleDialogSupplyOpen = async (data) => {
    setOpenSupplyDialog(true);
    setOpenData(data);
  };

  const handleDialogSupplyClose = async () => {
    setOpenSupplyDialog(false);
    setOpenData(null);
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Archived Supplies"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Supplies", to: "/supplies/cleaning/manage" },
          ]}
          BreadCrumbCurrentPageTitle={"Archive"}
        />
        <div className={isMobile ? "pv-20 ph-10" : "pv-24 ph-32"}>
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column pv-15 ph-12"
                : "d-flex flex-space-between flex-center mv-20"
            }
          >
            <div>
              <div
                className="text-foreground"
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                }}
              >
                Supply Archive Order
              </div>
              <div
                className="mv-10"
                style={{ fontSize: "16px", color: "#6B7280" }}
              >
                View and manage archived supply orders
              </div>
            </div>
          </div>
          <div
            className={isMobile ? `sectionBox2 ph-5 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]` : `sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            style={{
              // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              // borderRadius: "8px",
            }}
          >
            <div className="relative mb-4 w-65">
              <Search
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                size={18}
              />
              <Input
                placeholder="Search archived orders..."
                className="pl-40 bg-white dark:bg-[#0F1729]"
                value={searchTerm ? searchTerm : ""}
                onChange={(event) => {
                  setsearchTerm(event.target.value);
                }}
              />
            </div>
            {!isMobile && !isLandscape && (
              <ThemeTable
                rows={filteredList}
                headCells={getColumns}
                hidePagination={false}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
              />
            )}
            {(isMobile || isLandscape) && (
              <>
                {filteredList?.map((order, index) => {
                  return (
                    <Card key={order?.id} className="w-100 mb-20">
                      <CardHeader className="pb-2 p-24">
                        <div className="flex justify-between items-start">
                          <div>
                            <h3
                              className="font-semibold mb-3 text-[#020817] dark:text-white"
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                // color: "#020817",
                              }}
                            >
                              Order #{order?.orderId}
                            </h3>
                            <p
                              className="text-muted-foreground text-sm"
                              style={{ fontSize: "14px", color: "#64748B" }}
                            >
                              Order Date: {FormatedDates(order?.dateOfRequest)}
                            </p>
                          </div>
                          <Badge
                            variant={getPriorityBadgeVariant(order?.priority)}
                          >
                            {getPriorityLabel(order?.priority)}
                          </Badge>
                        </div>
                      </CardHeader>
                      <CardContent className="pb-8 ph-24 pt-0">
                        <div className="grid grid-cols-2 gap-2 text-sm">
                          <div>
                            <p
                              className="text-muted-foreground"
                              style={{ fontSize: "14px", color: "#64748B" }}
                            >
                              Client
                            </p>
                            <p className="text-[#020817] dark:text-white" style={{ fontSize: "14px"}}>
                              {order?.clientName}
                            </p>
                          </div>
                          <div>
                            <p
                              className="text-muted-foreground"
                              style={{ fontSize: "14px", color: "#64748B" }}
                            >
                              Employee
                            </p>
                            <p className="text-[#020817] dark:text-white" style={{ fontSize: "14px" }}>
                              {order?.employeeName}
                            </p>
                          </div>
                        </div>
                        <div className="mt-14 text-sm">
                          <p
                            className="text-muted-foreground"
                            style={{ fontSize: "14px", color: "#64748B" }}
                          >
                            Items
                          </p>
                          <ul className="list-disc list-inside">
                            {order?.supplyItems?.map((supply) => (
                              <li
                                key={supply?.id}
                                className="d-flex flex-center"
                              >
                                <span
                                  style={{
                                    width: 4,
                                    height: 4,
                                    backgroundColor: "#020817",
                                    borderRadius: "50%",
                                    marginRight: 6,
                                    display: "inline-block",
                                  }}
                                ></span>
                                {supply?.title} ({supply?.qty})
                              </li>
                            ))}
                          </ul>
                        </div>
                      </CardContent>
                      <CardFooter className="pt-0">
                        <Button
                          className="w-full"
                          variant="outline"
                          onClick={() => handleViewDetails(order)}
                        >
                          <Eye className="h-4 w-4 mr-2" /> View Details
                        </Button>
                      </CardFooter>
                    </Card>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </Container>

      <ArchivedDetailsDialog
        selectedOrder={currentRequest}
        showDetailsModal={detailsDialogOpen}
        setShowDetailsModal={setDetailsDialogOpen}
        handleUnarchive={handelUnArchive}
      />

      {dialogConfirmOpen && (
        <CommonConfirmationDialog
          open={dialogConfirmOpen}
          onConfirm={() => handleProceed(selectedItem)}
          onClose={handleDialogConfirmClose}
          title="Unarchive Order"
          message="Are you sure you want to UnArchive this item?"
          buttonTitle="Yes"
        />
      )}

      {rejectReasonDialogOpen && (
        <CommonConfirmationDialog
          open={rejectReasonDialogOpen}
          onConfirm={()=> { setRejectReasonDialogOpen(false); setSelectedItem(null); setDetailsDialogOpen(false);}}
          onClose={()=> { setRejectReasonDialogOpen(false); setSelectedItem(null); setDetailsDialogOpen(false);}}
          title="Alert"
          message="You cannot unarchive a rejected order. Please create a new order to proceed."
          buttonTitle="Ok"
        />
      )}

      <SuppplyDataDialog
        open={openSupplyDialog}
        onClose={handleDialogSupplyClose}
        listData={openData}
      />
    </>
  );
};

export default ArchiveSupplies;
